import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-977a2c00"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "news-page" }
const _hoisted_2 = { class: "top-cont center" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "inp" }
const _hoisted_5 = ["placeholder"]
const _hoisted_6 = { class: "content container" }
const _hoisted_7 = {
  key: 0,
  class: "not-found"
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = {
  class: "abs-img",
  alt: "Thumbnail"
}
const _hoisted_10 = { class: "title" }

import news from '@/jsons/news.json'
import { store } from '@/store/store';
import { ComputedRef, Ref, computed, ref } from 'vue';
import { device } from "@/modules/breakpoints"
import Footer from '@/components/Footer.vue';
import {newsModel} from '@/models/newsModel'
import { useHead } from '@vueuse/head'

const increaseNum: number = 9;

export default /*#__PURE__*/_defineComponent({
  __name: 'NewsPage',
  setup(__props) {

const Store = store();

const searchText: Ref<string> = ref('');
const sliceNum: Ref<number> = ref(9);

const sortedData:ComputedRef<newsModel[]> = computed(() => {
    const sortedData = news.filter(item => item.title.toLocaleLowerCase().includes(searchText.value.toLocaleLowerCase()));
    if (searchText.value.length > 3) {
        return sortedData.slice(0, sliceNum.value);
    } else {
        return news.slice(0, sliceNum.value)
    }
})

const loadMore = (): void => {
    sliceNum.value += increaseNum;
}

useHead({
  title: "Jortsoft videos",
  meta: [
    {
      name: "description",
      content: "Jortsoft videos page"
    },
    {
      property: "og:url",
      content: Store.getDomain
    },
    {
      property: "og:type",
      content: "website"
    },
    {
      property: "og:title",
      content: "Jortsoft videos page"
    },
    {
      property: "og:description",
      content: "Jortsoft videos page"
    },
    {
      property: "og:image",
      content: "https://opengraph.b-cdn.net/production/documents/e75df412-75d0-4e3b-8af8-d947120743b6.jpg?token=YD4SwTdd2E04mG9TgECpm4VrgAZB4VBEPf9T9_clrOA&height=675&width=1200&expires=33240107303"
    },
  ]
})
const getIframeUrl = (url: any): any => {
    return url.match(/watch\?v=([^&]+)/)[1];
}


return (_ctx: any,_cache: any) => {
  const _directive_lazy = _resolveDirective("lazy")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(Store).getCurrentLang == "GE" ? "ვიდეოები" : "Videos"), 1),
      _createElementVNode("div", _hoisted_4, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchText).value = $event)),
          placeholder: _unref(Store).getCurrentLang == 'GE' ? 'ძებნა...' : 'Search...'
        }, null, 8, _hoisted_5), [
          [_vModelText, searchText.value]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      (!sortedData.value.length)
        ? (_openBlock(), _createElementBlock("p", _hoisted_7, "Not Found data"))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedData.value, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "box",
          key: index
        }, [
          _createElementVNode("div", {
            onClick: ($event: any) => (_unref(Store).openVideoPopup(getIframeUrl(item.video)))
          }, [
            _createElementVNode("div", {
              class: "img",
              onMouseenter: _cache[1] || (_cache[1] = ($event: any) => (_unref(Store).setActiveMouse(true))),
              onMousemove: _cache[2] || (_cache[2] = ($event: any) => (_unref(Store).setActiveMouse(true))),
              onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (_unref(Store).setActiveMouse(false)))
            }, [
              _withDirectives(_createElementVNode("img", _hoisted_9, null, 512), [
                [_directive_lazy, { src: _unref(Store).getWindowWidth <= _unref(device).tablet ? item.thumbMobile : item.thumbDesktop, loading: require('@/assets/loading.gif') }]
              ])
            ], 32)
          ], 8, _hoisted_8),
          _createElementVNode("p", _hoisted_10, _toDisplayString(item.title), 1)
        ]))
      }), 128))
    ]),
    (sortedData.value.length && sliceNum.value <= _unref(news).length && searchText.value.length < 3)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "center pointer",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (loadMore()))
        }, [
          _createElementVNode("p", null, _toDisplayString(_unref(Store).getCurrentLang == 'GE' ? 'მეტი' : 'More'), 1)
        ]))
      : _createCommentVNode("", true),
    _createVNode(Footer)
  ]))
}
}

})